import { WidgetType } from '../../types';

export const GRID_CONTAINER_ID = 'keen-grid-container';

export const GRID_MARGIN = [20, 20];

export const GRID_COLS_VIEW_MODE = { lg: 12, md: 12, sm: 12, xs: 1, xxs: 1 };
export const GRID_COLS_EDIT_MODE = { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 };
export const COLUMNS_NUMBER_IN_EDIT_MODE = 12;

export const GRID_BREAKPOINTS = { lg: 1152, md: 996, sm: 768, xs: 480, xxs: 0 };

export const GRID_CONTAINER_PADDING = [0, 0];

export const DRAGGED_WIDGET_Z_INDEX = 1000;

export const WIDGETS_WITH_OVERLAY_DRAG: WidgetType[] = [
  'date-picker',
  'text',
  'filter',
];

export const ROW_HEIGHT = 10;
